/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-nan.js";
import "core-js/modules/es.string.sub.js";
import "core-js/modules/es.math.trunc.js";
import Vue from 'vue';
import store from './store';
import { box } from './utils/dev';
import axios from './api/request.js';
import DingTalk from 'DingTalk';
import Big from 'big.js';
import Devices from './utils/ntConfig';
Vue.prototype.$http = axios;

var install = function install(Vue) {
  Vue.prototype.$DingTalk = Devices;
  Vue.$http = axios;

  var androidBack = function androidBack(event) {
    var config = store.state.globalStore.androidBack;

    if (Object.keys(config).length > 0 && config.control) {
      config.onSuccess();
      event.preventDefault(); // 阻止默认的回退行为
    }
  };

  Vue.prototype.$log = console.log;

  Vue.prototype.$setBackbuttonListen = function () {
    document.addEventListener('backbutton', androidBack, false);
  };

  Vue.prototype.$fileTypeMap = function () {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return function (v) {
      return {
        file_type: type,
        file_url: v
      };
    };
  };

  Vue.prototype.$fileType = function () {
    var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return array.filter(function (v) {
      return v.file_type === type;
    });
  };

  Vue.filter('fileType', function () {
    var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return array.filter(function (v) {
      return v.file_type === type;
    }).map(function (v) {
      return v.file_url;
    });
  }); // 设置钉钉左侧按钮
  // Vue.prototype.$setLeft = (config) => {
  //   if (store.state.globalStore.RUN_ENV === 'Android') {
  //     store.commit('globalStore/_androidBack', config)
  //   } else if (store.state.globalStore.RUN_ENV === 'ios') {
  //     if (Vue.prototype.$DingTalk) {
  //       if (config.control) {
  //         Vue.prototype.$DingTalk.biz.navigation.setLeft({
  //           control: true, // 是否控制点击事件，true 控制，false 不控制， 默认false
  //           text: config.text || '返回', // 控制显示文本，空字符串表示显示默认文本
  //           onSuccess: (result) => {
  //             config.onSuccess()
  //           },
  //           onFail: (e) => {},
  //         })
  //       } else {
  //         Vue.prototype.$DingTalk.biz.navigation.setLeft({ control: false })
  //       }
  //     }
  //   }
  // }
  // 设置开发模式的右上角菜单

  if (process.env.NODE_ENV === 'development' && !Vue.prototype.$DingTalk) {
    Vue.prototype.$DingTalk = {
      biz: {
        navigation: {
          setMenu: function setMenu(options) {
            box.items.length = 0;
            box.show = true;
            Array.prototype.push.apply(box.items, options.items);
            box.onSuccess = options.onSuccess;
          },
          setRight: function setRight(v) {
            box.show = v.show;
          },
          setLeft: function setLeft() {},
          setTitle: function setTitle() {},
          hideBar: function hideBar() {}
        }
      },
      self: {
        getList: function getList() {
          return box.items || [];
        },
        isShow: function isShow() {
          return box.show;
        },
        onSuccess: function onSuccess(e) {
          box.onSuccess.call(this, e);
        }
      },
      ui: {
        pullToRefresh: {
          disable: function disable() {}
        },
        webViewBounce: {
          disable: function disable() {}
        }
      },
      ready: function ready(func) {
        return func();
      }
    };
  }

  Vue.config.productionTip = false; // Vue.prototype.$http = request

  /* eslint-disable no-extend-native */

  Date.prototype.Format = function (fmt) {
    var o = {
      'M+': this.getMonth() + 1,
      'D+': this.getDate(),
      'H+': this.getHours(),
      'm+': this.getMinutes(),
      's+': this.getSeconds(),
      'q+': Math.floor((this.getMonth() + 3) / 3),
      S: this.getMilliseconds()
    };

    if (/(Y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    }

    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
      }
    }

    return fmt;
  }; // 埋点


  Vue.prototype.$point = function (code) {}; // 免费功能锁定


  Vue.prototype.$freeLock = function () {
    var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (store.state.globalStore.user.isChargeUser === 0) {
      Vue.$vux.toast.text("\u514D\u8D39\u7248\u672C\u4E0D\u652F\u6301".concat(ctx, "\uFF0C\u5EFA\u8BAE\u5347\u7EA7\u4E3AVIP\u7248\u672C\uFF0C\u5BA2\u670D\u70ED\u7EBF0592-3278627"));
      return false;
    } else {
      return true;
    }
  };

  Vue.prototype.$openLink = function (url) {
    try {
      DingTalk.isDingtalk() ? DingTalk.biz.util.openLink({
        url: url,
        onFail: function onFail(e) {
          return alert('打开失败：' + url);
        }
      }) : window.open(url);
    } catch (error) {
      alert(error);
    }
  };

  Vue.prototype.$remTopx = function (rem) {
    var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
    fontSize = Number(fontSize.substr(0, fontSize.length - 2));
    return rem * fontSize;
  };

  Object.defineProperty(Vue.prototype, '$env', {
    get: function get() {
      return process.env.VUE_APP_MODE;
    }
  }); // 计算浮点数的精度

  Vue.prototype.$calcStep = function (num) {
    var origin = Math.abs(num);

    if (Number.isNaN(origin) || origin === 0) {
      return 1;
    } else {
      var decimal = new Big(origin).sub(Math.trunc(origin));

      if (decimal === 0) {
        return 1;
      } else {
        return Number(String(decimal).replace(/\d\B/g, function (e) {
          return 0;
        }).replace(/\d$/g, 1));
      }
    }
  };

  Vue.mixin({
    data: function data() {
      return {
        backChange: null
      };
    },
    destroyed: function destroyed() {
      if (this.backChange) {
        window.removeEventListener('popstate', this.backChange, false);
      }
    },
    methods: {
      $setLeft: function $setLeft(config) {
        try {
          this.backChange = config.onSuccess || function noop() {};

          if (config.control) {
            history.pushState(null, null, document.URL);
            window.addEventListener('popstate', this.backChange, false);
          } else {
            window.removeEventListener('popstate', this.backChange, false);
            this.backChange = null;
          }
        } catch (error) {
          console.log('AutoConsole: noop -> error', error);
        }
      }
    }
  });
};

export default install;